module.exports = __webpack_public_path__ + "img/program-talk.b587da83.jpg";